module.exports = __webpack_public_path__ + "img/icon14.f78e845f.svg";